import * as types from "./mutation_types";

export default {
  [types.SESSION_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.SESSION_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.SESSION_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.SESSION_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
